<template>
  <div class="user-list-admin">
    <section class="bottom-section">
      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
    </section>
    <el-table v-loading="loading" :data="usersList" style="width: 100%">
      <el-table-column
        label="ФИО"
        prop="fio"
        header-align="center"
        align="center"
      />
      <el-table-column
        label="Логин"
        prop="login"
        header-align="center"
        align="center"
      />
      <el-table-column
        label="Тип пользователя"
        prop="user_type"
        header-align="center"
        align="center"
      />
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <div class="search-block">
            <el-button size="mini" icon="el-icon-close" @click="clearSearch" />
            <el-input
              v-model="search_input"
              class="search-input"
              placeholder="Введите для поиска"
              @keyup.enter.native="getUsers"
            />
            <el-button size="mini" icon="el-icon-search" @click="getUsers" />
          </div>
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="handleSelect(scope.row)">
            Выбрать
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { CHANGE_PROFILE } from '@/store/actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'
import PaginationCustom from '@/components/Tables/PaginationCustom'

const Users = RepositoryFactory.get('users')

export default {
  name: 'UsersList',
  components: { PaginationCustom },
  data() {
    return {
      search_input: '',
      curPage: 1,
    }
  },
  computed: {
    ...mapGetters({
      user: 'userProfile/getByKey',
      loading: 'users/getLoading',
      pagination: 'users/getPagination',
      usersList: 'users/getUsers',
    }),
  },
  created() {
    this.getUsers()
  },
  methods: {
    handleSelect(row) {
      Users.getUserToken(row.id).then(res => {
        const { status, data } = res

        if (status === 200 && data.token) {
          this.$store.dispatch(`userProfile/${CHANGE_PROFILE}`, data)
          this.$emit('choosed')
        } else {
          this.$message({
            showClose: true,
            message: 'Произошла ошибка при смене пользователя',
            type: 'error',
            duration: 5000,
          })
        }
      })
    },
    getUsers() {
      const search = {}
      const filterValue = String(this.search_input).trim()

      if (filterValue) {
        search.search = filterValue
      }
      this.$store.dispatch('users/fetchUsers', { page: this.curPage, search })
    },
    clearSearch() {
      this.search_input = ''
      this.changePage()
    },
    changePage(page = 1) {
      this.curPage = page
      this.getUsers()
    },
  },
}
</script>

<style lang="sass">
.user-list-admin
  .search-block
    display: flex
    padding: 0
    .search-input
      padding: 0
</style>
